import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./MyInfoTabs.module.css";

const TAB_OPTIONS = [
  { id: "stats", label: "Stats" },
  { id: "nameList", label: "Name List" },
  { id: "info", label: "Info" },
];

export const MyInfoTabs = ({ activeTab, onTabChange }) => {
  return (
    <div className={styles.container} role="tablist" aria-label="My Info tabs">
      {TAB_OPTIONS.map((tab) => {
        const isActive = activeTab === tab.id;

        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onTabChange(tab.id)}
            className={classNames(styles.tabButton, {
              [styles.active]: isActive,
              [styles.inactive]: !isActive,
            })}
          >
            <span className={styles.tabLabel}>{tab.label}</span>
          </button>
        );
      })}
    </div>
  );
};

MyInfoTabs.propTypes = {
  activeTab: PropTypes.oneOf(["stats", "nameList", "info"]).isRequired,
  onTabChange: PropTypes.func.isRequired,
};
